<template>
  <div>
    <alert
      :visible="!!alert_message"
      dark
      :type="type_alert"
      :message="alert_message"
      :clickClose="() => (alert_message = '')"
    />
    <v-data-table
      :headers="headers"
      :loading="loading"
      :items="promotions"
      :search="search"
      sort-by="end_date"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>PROMOÇÕES</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Busca"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.status="{ item }">
        <v-chip :color="getColor(item.status)" dark>
          {{ getLabel(item.status) }}
        </v-chip>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.start_date="{ item }">
        {{ item.start_date | dateFormatBr }}
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.company_id="{ item }">
        {{ item.provider.code }} - {{ item.provider.name }}
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.type="{ item }">
        {{ getTextType(item.type) }}
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.payment="{ item }">
        {{ getLabelPromotion(item) }}
        <!-- {{ item.payment == null ? "TODAS AS CONDIÇÕES" : item.payment.name }} -->
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.discount="{ item }">
        {{ item.discount }}%
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.end_date="{ item }">
        {{ item.end_date | dateFormatBr }}
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.actions="{ item }">
        <v-tooltip top color="green darken-1">
          <!-- eslint-disable-next-line -->
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              color="green darken-1"
              @click="showProducts(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-eye
            </v-icon>
          </template>
          <span>Visualizar Produtos</span>
        </v-tooltip>
        <v-tooltip top color="black">
          <!-- eslint-disable-next-line -->
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              @click="orderPromotion(item)"
              small
              >Fazer Pedido</v-btn
            >
          </template>
          <span>Fazer Pedido com esta Promoção</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data> Não exitem promoções no momento </template>
    </v-data-table>
    <v-dialog v-model="dialogShowProducts" max-width="1100px">
      <v-card>
        <v-card-title>
          <span>
            Produtos da Promoção: {{ promotion.id }} -
            {{ promotion.description }}
          </span>
          <v-spacer></v-spacer>
          <v-icon @click="dialogShowProducts = false"> mdi-close </v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4">
          <v-row>
            <v-col cols="12" md="6">
              <label class="font-weight-medium black--text"> Fornecedor: </label
              ><label class="font-weight-bold black--text"
                >{{ promotion.provider.code }} -
                {{ promotion.provider.name }}
              </label>
            </v-col>
            <v-col cols="12" md="3"
              ><label class="font-weight-medium black--text"
                >Data Inicial:
              </label>
              <label class="font-weight-bold black--text">{{
                promotion.start_date | dateFormatBr
              }}</label></v-col
            >
            <v-col cols="12" md="3"
              ><label class="font-weight-medium black--text"
                >Data Final:
              </label>
              <label class="font-weight-bold black--text"
                >{{ promotion.end_date | dateFormatBr }}
              </label></v-col
            >
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <label class="font-weight-medium black--text">Tipo:</label>
              <label class="font-weight-bold black--text">
                {{ getTextType(promotion.type) }}
              </label></v-col
            >
            <v-col cols="12" md="3" v-if="promotion.type !== 3">
              <label class="font-weight-medium black--text">
                Cond. Pagto.:
              </label>
              <label class="font-weight-bold black--text">
                {{
                  promotion.payment == null
                    ? "Todas as condições"
                    : promotion.payment.name
                }}
              </label>
            </v-col>
            <v-col cols="12" md="3" v-if="promotion.type !== 3"
              ><label class="font-weight-medium black--text">Desconto: </label
              ><label class="font-weight-bold black--text"
                >{{ promotion.discount }}%</label
              ></v-col
            >
          </v-row>
          <v-row>
            <v-col>
              <label class="text-h6">Produtos</label>
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="products.length > 0">
              <v-data-table
                :headers="headers_products"
                :items="products"
                :items-per-page="10"
                item-key="id"
                class="elevation-1"
                dense
              >
                <template v-slot:[`item.photo`]="{ item }">
                  <v-img
                    :src="getUrlPhoto(item.photo)"
                    alt=""
                    max-width="120"
                    :aspect-ratio="16 / 9"
                    class="my-2 image-clickable"
                    @click="onClickImage(getUrlPhoto(item.photo))"
                  ></v-img>
                </template>
                <template v-slot:[`item.reference`]="{ item }">
                  {{ item.provider_code }}{{ item.reference }}
                </template>
                <template v-slot:[`item.price`]="{ item }">
                  {{ getPrice(promotion, item) }}
                  <br />
                  <label class="font-weight-bold">
                    {{ getNewPrice(promotion, item) }}
                  </label>
                </template>
                <template v-slot:no-data
                  >PROMOÇÃO VÁLIDA PARA TODOS OS PRODUTOS</template
                >
              </v-data-table>
            </v-col>
            <v-col v-if="products.length === 0">
              <label class="text-h6 black--text"
                >PROMOÇÃO VÁLIDA PARA TODOS OS PRODUTOS</label
              >
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            outlined
            @click="() => (dialogShowProducts = false)"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ImageZoom
      :visible="dialog_zoom_photo"
      :closeDialog="closeDialogZoomPhoto"
      :photo="photo_dialog"
    />
  </div>
</template>

<script>
import { URL_IMAGE } from "@/api/config";
import * as CompanyPromotionAPI from "@/api/requests/CompanyPromotionRequest";

import Alert from "@/components/Alert";
import ImageZoom from "@/components/ImageZoom";

export default {
  components: {
    Alert,
    ImageZoom,
  },
  data: () => ({
    dialogDelete: false,
    search: "",
    loading: false,
    headers: [
      {
        text: "ID",
        align: "right",
        value: "id",
        width: 50,
      },
      { text: "Fornecedor", value: "company_id", width: 180 },
      { text: "Descrição", value: "description", width: 180 },
      { text: "Tipo", value: "type", width: 180 },
      { text: "Detalhamento", value: "payment", width: 180 },
      // { text: "Desconto", value: "discount", width: 100 },
      { text: "Data Inicial", value: "start_date", width: 100 },
      { text: "Data Final", value: "end_date", width: 100 },
      {
        text: "Ação",
        value: "actions",
        sortable: false,
        width: 180,
        align: "right",
      },
    ],
    typePromotions: [
      { value: 1, text: "Desconto na condição de pagamento" },
      { value: 2, text: "Promoção de prazo especial" },
      { value: 3, text: "Promoção de produtos (preço)" },
    ],
    promotions: [],
    promotion: {
      id: "",
      provider_id: "",
      description: "",
      status: "1",
      type: "",
      start_date: "",
      end_date: "",
      payment_condition_id: "",
      discount: "",
      payment: null,
      provider: {},
    },
    products: [],
    editedItem: {
      name: "",
      status: 1,
    },
    defaultItem: {
      name: "",
      status: 1,
    },
    headers_products: [
      { text: "Foto", value: "photo" },
      { text: "Referência", value: "reference" },
      { text: "Nome", value: "name" },
      { text: "Categoria", value: "category_name" },
      { text: "Subcategoria", value: "subcategory_name" },
      { text: "Preço", value: "price", align: "right" },
    ],
    dialog_zoom_photo: false,
    photo_dialog: "",
    dialogShowProducts: false,
    alert_message: "",
    type_alert: "error",
  }),

  computed: {},

  watch: {},
  filters: {
    dateFormatBr: function (value) {
      return value.split("-").reverse().join("/");
    },
    currencyEuaToBr: function (value) {
      if (!value) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      await this.getPromotions();
    },

    getColor(status) {
      return status == 1 ? "green" : "red";
    },
    getLabel(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },

    async getPromotions() {
      this.loading = true;
      this.promotions = [];
      try {
        this.promotions = await CompanyPromotionAPI.getAll("?active=true");
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getPromotion(id) {
      this.loading = true;
      try {
        let response = await CompanyPromotionAPI.getById(id);
        this.promotion = response.promotion;
        this.products = response.products;

        // TRATANDO DATA INICIAL
        this.promotion.start_date =
          this.promotion.start_date !== ""
            ? this.dateFormatToBr(this.promotion.start_date)
            : this.promotion.start_date;

        // TRATANDO DATA FINAL
        this.promotion.end_date =
          this.promotion.end_date !== ""
            ? this.dateFormatToBr(this.promotion.end_date)
            : this.promotion.end_date;
        this.dialogShowProducts = true;
      } catch (error) {
        this.alert_message =
          "Não foi possível carregar os produtos dessa promoção, entre em contato com o suporte";
        this.type_alert = "error";
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    showProducts(item) {
      this.getPromotion(item.id);
      // this.$router.push({ name: "NcmEdit", params: { id: item.id } });
    },
    dateFormatToBr(date) {
      if (date == "") return "";
      return date.split("-").reverse().join("/");
    },
    dateFormatToEua(date) {
      if (date == "") return "";
      return date.split("/").reverse().join("-");
    },
    orderPromotion(item) {
      console.log(item);
      this.$router.push({
        name: "CreateInvoice",
        params: { company_promotion_id: item.id },
      });
    },

    getUrlPhoto(photo) {
      if (photo !== "") {
        return `${URL_IMAGE}${photo}`;
      } else {
        return "";
      }
    },
    onClickImage(photo) {
      if (photo == "") return;
      this.photo_dialog = photo;
      this.dialog_zoom_photo = true;
    },
    closeDialogZoomPhoto() {
      this.dialog_zoom_photo = false;
      this.photo_dialog = "";
    },
    getTextType(type) {
      if (type === "") return "";
      console.log(type);
      return this.typePromotions.find((item) => item.value === type).text;
    },
    getLabelPromotion(item) {
      if (item.type == 3) return "";
      if (item.payment === null) {
        return `Desconto: ${item.discount}% em todas as condições`;
      } else {
        if (item.type === 2) {
          return `Condição: ${item.payment.name}`;
        } else {
          return `${item.discount}% em ${item.payment.name}`;
        }
      }
    },
    currencyEuaToBr(value) {
      if (!value) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    getPrice(promotion, item) {
      // if (promotion.type == 3) {
      return `de: ${this.currencyEuaToBr(item.price_cif)}`;
      // } else {
      //   return this.currencyEuaToBr(this.price_cif);
      // }
    },
    getNewPrice(promotion, item) {
      // if (promotion.type == 3) {
      return `por: ${this.currencyEuaToBr(item.new_price_cif)}`;
      // } else {
      //   return "";
      // }
    },
  },
};
</script>
